(function () {
    'use strict';
    angular.module('aprima-core-ui').factory('PressListenerService', [
        'NgZoneService',
        PressListenerService,
    ]);

    function PressListenerService(
        NgZoneService
    ) {
        return {
            register: register,
        };

        function register(element, handlerFn) {
            var result = NgZoneService.contextRun(function (zoneAwareObject) {
                return zoneAwareRegister(element, handlerFn, zoneAwareObject);
            });
            return result;
        }

        // This zoneAwareObject always needs to be the last parameter to this function.
        function zoneAwareRegister(element, handlerFn, zoneAwareObject) {
            // see comments in ClickListenerService for why this is necessary
            var zoneAwareHandlerFn = zoneAwareObject.wrapToRunInZoneIfNecessary(handlerFn);

            // don't create multiple Hammer instances per element
            var hammer = element.data('hammer');
            var shouldDestroy = false;
            if (!hammer) {
                hammer = new Hammer.Manager(element[0]);

                // we are creating a new instance in this function,
                // so it needs to be cleaned up in here as well, below in the dereg function
                shouldDestroy = true;

                element.data('hammer', hammer);
            }
            hammer.add(new Hammer.Press());
            hammer.on('press', zoneAwareHandlerFn);

            return function hmPressCleanup() {
                hammer.off('press', zoneAwareHandlerFn);

                if (shouldDestroy) {
                    hammer.destroy();
                }
            };
        }
    }
})();